import { render } from "./DiagnosisTile.vue?vue&type=template&id=054aebe1&scoped=true&ts=true&lang=pug"
import script from "./DiagnosisTile.vue?vue&type=script&lang=ts"
export * from "./DiagnosisTile.vue?vue&type=script&lang=ts"

import "./DiagnosisTile.vue?vue&type=style&index=0&id=054aebe1&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054aebe1"]])

export default __exports__